import React from 'react';
import SensorStatusDot from '../../components/sensors/SensorStatusDot';
import { EnumStatusColors } from '../../models/commonEnums';

export type Props = {
    name: string;
    statusColor?: EnumStatusColors;
    firstRow?: string;
    secondRow?: string;
    firstRowLogo?: React.ReactElement;
};

const IntegrationRowContent = (props: Props): React.ReactElement => {
    const { statusColor, name, firstRow, secondRow, firstRowLogo } = props;

    return (
        <div className="centered integration-row__text">
            {statusColor && <SensorStatusDot color={statusColor} />}
            <div className="list__row__text-container">
                <h3 className="list__row__text-container__header">{name}</h3>
                <div className="list__row__text-container__single-line-content">
                    {firstRowLogo && (
                        <span className="list__row__text-container__single-line-content__img">{firstRowLogo}</span>
                    )}
                    <span className="list__row__text-container__single-line-content__text">{firstRow}</span>
                </div>
                <div className="list__row__text-container__single-line-content__text">{secondRow}</div>
            </div>
        </div>
    );
};

export default IntegrationRowContent;
